import _asyncToGenerator from "/builds/unifygroup/uno/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator";

var _process$env$NEXT_PUB;

import _regeneratorRuntime from "/builds/unifygroup/uno/app/node_modules/next/dist/compiled/@babel/runtime/regenerator";
import forEach from 'lodash/forEach';
import { getSignedUrl } from 'services/networking/file-upload';
var bucketConfigKey = (_process$env$NEXT_PUB = process.env.NEXT_PUBLIC_CONTENT_BUCKET_CONFIG_KEY) !== null && _process$env$NEXT_PUB !== void 0 ? _process$env$NEXT_PUB : 'undefinedBucketConfigKey';
export var uploadFile = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(file) {
    var _yield$getSignedUrl, url, fields, cdnFileUrl, formData, response;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return getSignedUrl(bucketConfigKey, file.name, file.type);

          case 2:
            _yield$getSignedUrl = _context.sent;
            url = _yield$getSignedUrl.url;
            fields = _yield$getSignedUrl.fields;
            cdnFileUrl = _yield$getSignedUrl.cdnFileUrl;
            formData = new FormData();
            formData.append('Content-Type', file.type);
            forEach(fields, function (value, key) {
              return formData.append(key, value);
            }); // `file` parameter has to be last

            formData.append('file', file);
            _context.next = 12;
            return fetch(url, {
              method: 'POST',
              body: formData
            });

          case 12:
            response = _context.sent;

            if (!response.ok) {
              _context.next = 15;
              break;
            }

            return _context.abrupt("return", {
              response: response,
              cdnFileUrl: cdnFileUrl
            });

          case 15:
            throw new Error(response.statusText);

          case 16:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function uploadFile(_x) {
    return _ref.apply(this, arguments);
  };
}();